export default function MySQL_WHERE() {
  return (
    <div>
      <h2>MySQL_WHERE</h2>    </div>
  );
}